import {useEffect, useState} from "react";
import * as React from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import StaffVetRegistrationsShowFilters from "./StaffVetRegistrationsShowFilters";
import StaffVetRegistrationsShowTableRow from "./StaffVetRegistrationsShowTableRow";

export default function StaffVetRegistrations() {

    const [loadingCampaigns, setLoadingCampaigns] = useState(true);
    const [loadingNew, setLoadingNew] = useState(true);
    const [loadingApproved, setLoadingApproved] = useState(true);
    const [loadingSuccess, setLoadingSuccess] = useState(true);
    const [data, setData] = useState([]);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [dataApproved, setDataApproved] = useState([]);
    const [dataSuccess, setDataSuccess] = useState([]);
    const [view, setView] = useState('new');

    useEffect(() => {
        loadCampaigns();
    }, [])

    useEffect(() => {
        loadNew();
        loadApproved();
        loadSuccess();
    }, [view, loadingNew, loadingApproved, loadingSuccess]);

    function loadNew() {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/register/open'),
            setData, loadingNew, setLoadingNew
        )
    }


    function loadCampaigns() {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/campaign/registration/search'),
            setDataCampaign, loadingCampaigns, setLoadingCampaigns
        )
    }

    function loadApproved() {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/register/approved'),
            setDataApproved, loadingApproved, setLoadingApproved
        )
    }

    function loadSuccess() {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/register/completed'),
            setDataSuccess, loadingSuccess, setLoadingSuccess
        )
    }

    if (loadingCampaigns === true || loadingSuccess === true || loadingApproved === true || loadingNew === true) return "Loading...";
    return (
        <div>
            <StaffVetRegistrationsShowFilters view={view} setView={setView} newName={data.length}
                                              approved={dataApproved.length}
                                              success={dataSuccess.length}/>
            <TableContainer>
                <Table sx={{minWidth: 650}}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Clinic</TableCell>
                            <TableCell align="left">Contact</TableCell>
                            <TableCell align="left">Address</TableCell>
                            <TableCell align="left">Registered at</TableCell>
                            <TableCell align="left">Capacity</TableCell>
                            <TableCell align="center">Approval</TableCell>
                            <TableCell align="center">Finance completed</TableCell>
                            <TableCell align="center">Ready for Migration</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            (view === 'new') ?
                                <>
                                    {data.map((row, idx) => {
                                        return (
                                            <StaffVetRegistrationsShowTableRow key={idx} row={row} idx={idx}
                                                                               setLoading={setLoadingNew}
                                                                               setLoadingApproved={setLoadingApproved}
                                                                               setLoadingSuccess={setLoadingSuccess}
                                                                               dataCampaign={dataCampaign}
                                            />
                                        )
                                    })}
                                </>
                                : undefined
                        }
                        {
                            (view === 'approved') ?
                                <>
                                    {dataApproved.map((row, idx) => {
                                        return (
                                            <StaffVetRegistrationsShowTableRow key={idx} row={row} idx={idx}
                                                                               setLoading={setLoadingNew}
                                                                               setLoadingApproved={setLoadingApproved}
                                                                               setLoadingSuccess={setLoadingSuccess}
                                                                               dataCampaign={dataCampaign}
                                            />
                                        )
                                    })}
                                </>
                                : undefined
                        }
                        {
                            (view === 'success') ?
                                <>
                                    {dataSuccess.map((row, idx) => {
                                        return (
                                            <StaffVetRegistrationsShowTableRow key={idx} row={row} idx={idx}
                                                                               setLoading={setLoadingNew}
                                                                               setLoadingApproved={setLoadingApproved}
                                                                               setLoadingSuccess={setLoadingSuccess}
                                                                               dataCampaign={dataCampaign}
                                            />
                                        )
                                    })}
                                </>
                                : undefined
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
